import React from "react";
import { Link } from "react-router-dom";

import CollageEditor from "../components/CollageEditor";

function CollagePage() {
  return (
    <div style={{ padding: 16 }}>
      <div style={styles.header}>
        <Link to="/" style={styles.logo}>striply</Link>
        <nav style={styles.nav}>
          <Link to="/editor" style={styles.navLink}>Editor</Link>
          <Link to="/about" style={styles.navLink}>About</Link>
        </nav>
      </div>
      <div style={styles.caption}>
        <span style={styles.captionTitle}>Collage</span>
        <span style={styles.captionSub}> — cut, arrange, and export reference art for your panels</span>
      </div>
      <CollageEditor />
    </div>
  );
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  logo: {
    fontSize: 28,
    fontWeight: 700,
    color: "#1a1a1a",
    textDecoration: "none",
    fontFamily: "'Georgia', serif",
  },
  nav: {
    display: "flex",
    gap: 20,
  },
  navLink: {
    color: "#555",
    textDecoration: "none",
    fontSize: 15,
  },
  caption: {
    marginBottom: 12,
    fontFamily: "'Georgia', serif",
  },
  captionTitle: {
    fontSize: 15,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 2,
    color: "#1a1a1a",
  },
  captionSub: {
    fontSize: 13,
    fontStyle: "italic",
    color: "#6b6455",
  },
};

export default CollagePage;
